import { CategoryType } from '@diritto/common/content/constants';

export enum GlobalNavigationMenu {
  Home = 'Home',
  Explore = 'Explore',
  Ranking = 'Ranking',
  My = 'My',
  Quest = 'Quest',
}

export enum CategoryNavigationMenu {
  All = 'All',
  RomanceFantasy = 'RomanceFantasy',
  Romance = 'Romance',
  BL = 'BL',
  Fantasy = 'Fantasy',
  Any = 'Any',
  FanFiction = 'FanFiction',
}

export const CategoryNavigationMenuDisplayList = [
  CategoryNavigationMenu.All,
  CategoryNavigationMenu.Fantasy,
  CategoryNavigationMenu.BL,
  CategoryNavigationMenu.RomanceFantasy,
  CategoryNavigationMenu.Romance,
  CategoryNavigationMenu.Any,
  CategoryNavigationMenu.FanFiction,
];

export const CategoryNavigationMenuText = {
  [CategoryNavigationMenu.All]: '전체',
  [CategoryNavigationMenu.Fantasy]: '판타지',
  [CategoryNavigationMenu.BL]: 'BL',
  [CategoryNavigationMenu.RomanceFantasy]: '로판',
  [CategoryNavigationMenu.Romance]: '로맨스',
  [CategoryNavigationMenu.Any]: '자유',
  [CategoryNavigationMenu.FanFiction]: '팬픽',
};

export const CategoryNavigationMenuPath = {
  [CategoryNavigationMenu.All]: 'all',
  [CategoryNavigationMenu.Fantasy]: 'fantasy',
  [CategoryNavigationMenu.BL]: 'bl',
  [CategoryNavigationMenu.RomanceFantasy]: 'rofan',
  [CategoryNavigationMenu.Romance]: 'romance',
  [CategoryNavigationMenu.Any]: 'any',
  [CategoryNavigationMenu.FanFiction]: 'fanfiction',
};

export const CategoryNavMenuToCategoryMap = {
  [CategoryNavigationMenu.All]: undefined,
  [CategoryNavigationMenu.RomanceFantasy]: CategoryType.RomanceFantasy,
  [CategoryNavigationMenu.Romance]: CategoryType.Romance,
  [CategoryNavigationMenu.BL]: CategoryType.BL,
  [CategoryNavigationMenu.Fantasy]: CategoryType.Fantasy,
  [CategoryNavigationMenu.Any]: CategoryType.Any,
  [CategoryNavigationMenu.FanFiction]: CategoryType.FanFiction,
};

export enum LibraryNavigationMenu {
  Recently = 'Recently',
  Favorites = 'Favorites',
}

export const LibraryNavigationMenuDisplayList = [LibraryNavigationMenu.Favorites, LibraryNavigationMenu.Recently];

export const LibraryNavigationMenuText = {
  [LibraryNavigationMenu.Recently]: '최근 본',
  [LibraryNavigationMenu.Favorites]: '좋아요',
};

export const LibraryNavigationMenuPath = {
  [LibraryNavigationMenu.Recently]: 'recently',
  [LibraryNavigationMenu.Favorites]: 'favorites',
};

export enum RankingNavigationMenu {
  Series = 'Series',
  ActivityPoint = 'ActivityPoint',
}

export const RankingNavigationMenuDisplayList = [RankingNavigationMenu.Series, RankingNavigationMenu.ActivityPoint];

export const RankingNavigationMenuText = {
  [RankingNavigationMenu.Series]: '작품 랭킹',
  [RankingNavigationMenu.ActivityPoint]: '퀘스트 랭킹',
};

export enum RankingActivityPointNavigationMenu {
  My = 'My',
  All = 'All',
}

export const RankingActivityPointNavigationMenuDisplayList = [
  RankingActivityPointNavigationMenu.All,
  RankingActivityPointNavigationMenu.My,
];

export const RankingActivityPointNavigationMenuText = {
  [RankingActivityPointNavigationMenu.My]: '내 프로필 랭킹',
  [RankingActivityPointNavigationMenu.All]: '전체 랭킹',
};

export enum MyQuestNavigationMenu {
  OngoingSeason = 'OngoingSeason',
  EndedSeason = 'EndedSeason',
}

export const MyQuestNavigationMenuDisplayList = [
  MyQuestNavigationMenu.OngoingSeason,
  MyQuestNavigationMenu.EndedSeason,
];

export const MyQuestNavigationMenuText = {
  [MyQuestNavigationMenu.OngoingSeason]: '진행 중인 시즌',
  [MyQuestNavigationMenu.EndedSeason]: '종료된 시즌',
};

export const MyQuestNavigationMenuPath = {
  [MyQuestNavigationMenu.OngoingSeason]: '/quest/ongoing-season/my',
  [MyQuestNavigationMenu.EndedSeason]: '/quest/ended-season/my',
};

export enum QuestNavigationMenu {
  Ranking = 'Ranking',
  MyQuest = 'MyQuest',
}

export const QuestNavigationMenuDisplayList = [QuestNavigationMenu.Ranking, QuestNavigationMenu.MyQuest];

export const QuestNavigationMenuText = {
  [QuestNavigationMenu.Ranking]: '랭킹',
  [QuestNavigationMenu.MyQuest]: '내 퀘스트',
};

export const QuestNavigationMenuPath = {
  [QuestNavigationMenu.Ranking]: '/quest/ranking',
  [QuestNavigationMenu.MyQuest]: MyQuestNavigationMenuPath[MyQuestNavigationMenu.OngoingSeason],
};

export const GlobalNavigationDirectionText = {
  [GlobalNavigationMenu.Home]: '홈으로 가기',
  [GlobalNavigationMenu.Explore]: '둘러보기',
} as const;
